import { render, staticRenderFns } from "./competeFiles.vue?vue&type=template&id=7879322a&"
import script from "./competeFiles.vue?vue&type=script&lang=js&"
export * from "./competeFiles.vue?vue&type=script&lang=js&"
import style0 from "./competeFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports